let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("68Mmc")).then(() => parcelRequire('50j5y'));